import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import ArticleCategory from '@/store/entities/articles/article-category'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations'

interface CateState extends ListState<ArticleCategory>{
    editCate: ArticleCategory
}

class ArticleCategoryModule extends ListModule<CateState,any,ArticleCategory> {
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<ArticleCategory>(),
        loading:false,
        editCate:new ArticleCategory()
    };
    actions = {
        async getAll(context:ActionContext<CateState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ArticleCategory/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<ArticleCategory>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CateState,any>,payload:any){
            await Ajax.post('/api/services/app/ArticleCategory/Create',payload.data);
        },
        async update(context:ActionContext<CateState,any>,payload:any){
            await Ajax.put('/api/services/app/ArticleCategory/Update',payload.data);
        },
        async delete(context:ActionContext<CateState,any>,payload:any){
            await Ajax.delete('/api/services/app/ArticleCategory/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CateState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ArticleCategory/Get?Id='+payload.id);
            return reponse.data.result as ArticleCategory;
        }
    };
    mutations={
        setCurrentPage(state:CateState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CateState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CateState,ArticleCategory:ArticleCategory){
            state.editCate=ArticleCategory;
        }
    }
}

const articleCategoryModule = new ArticleCategoryModule();
export default articleCategoryModule;